import { render } from "./addWidget.vue?vue&type=template&id=13b48212"
import script from "./addWidget.vue?vue&type=script&lang=js"
export * from "./addWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__